<template>
  <div>
    <v-list-item @click.stop="dialog = true">
      <v-list-item-title>Set Unavailability</v-list-item-title>
    </v-list-item>

    <v-dialog width="fit-content" max-width="850px" v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Driver's Unavailability</span>
          <div class="dialog-closeBtn" @click="dialog = false">
            <v-icon left>mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-tabs
              v-model="tab_edit_working_time"
              background-color="grey lighten-4"
              fixed-tabs
              slider-color="grey darken-1"
              style="margin-bottom:16px"
            >
              <v-tab>Unavailability</v-tab>
              <v-tab>Leave</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab_edit_working_time">
              <!-- tab 1 default working time -->
              <v-tab-item>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    v-for="working_time in default_working_times"
                    :key="working_time.weekday_index"
                  >
                    <v-banner single-line>
                      {{working_time.weekday_name}}
                      <template v-slot:actions>
                        <v-btn color="primary" text @click="onAddWorkingPeriod(working_time.weekday_index)" :disabled="isCurrentDayHasHoliday(working_time.weekday_index)">
                          <v-icon left>mdi-plus</v-icon>Add Unavailability
                        </v-btn>
                      </template>
                    </v-banner>
                    <v-row
                      v-for="(working_period, key) in working_time.working_periods"
                      :key="working_period.id"
                    >
                      <v-col cols="12" md="4" v-if="!isCurrentDayHasHoliday(working_time.weekday_index)">
                        <v-autocomplete
                          class="hide-time-picker-indicator"
                          type="time"
                          menu-props="auto, overflowY"
                          clear-icon="mdi-close"
                          prepend-icon="mdi-clock-outline"
                          clearable
                          outlined
                          hint="Example: 08:00"
                          required
                          v-model="working_period.start_at"
                          :items="timeList"
                          item-text="name"
                          item-value="value"
                          :disabled="isCurrentDayHasHoliday(working_time.weekday_index)"
                          :error-messages="working_period_errors_start_at[working_time.weekday_index][key]"
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" v-if="!isCurrentDayHasHoliday(working_time.weekday_index)">
                        <v-autocomplete
                          class="hide-time-picker-indicator"
                          type="time"
                          menu-props="auto, overflowY"
                          clear-icon="mdi-close"
                          prepend-icon="mdi-clock-outline"
                          clearable
                          outlined
                          hint="Example: 20:00"
                          required
                          v-model="working_period.stop_at"
                          :items="timeList"
                          item-text="name"
                          item-value="value"
                          :disabled="isCurrentDayHasHoliday(working_time.weekday_index)"
                          :error-messages="working_period_errors_stop_at[working_time.weekday_index][key]"
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="8" v-if="isCurrentDayHasHoliday(working_time.weekday_index)">
                        Unavailable – All Day
                      </v-col>
                      <v-col cols="12" md="2" class="align-self-start">
                        <v-switch class="mt-1" v-model="working_period.holiday" :false-value="IS_REGULAR_DAY" :true-value="IS_HOLIDAY" :label="`Holiday`" @change="onChangeHoliday(working_time.weekday_index, key)" hide-details></v-switch>
                      </v-col>
                      <v-col cols="12" md="2" class="align-self-start pt-2">
                        <v-btn color="error" class="float-right" @click="onRemoveWorkingPeriod(working_time.weekday_index, key)">
                          <v-icon left>mdi-close</v-icon>Remove
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="!working_time.working_periods.length">
                      <v-col cols="12" md="12" style="text-align:center">
                        Available
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <!--/ tab 1 default working time -->
              <!-- tab 2 overriden working time -->
              <v-tab-item>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-sheet class="d-flex justify-space-between">
                      <v-btn
                        icon
                        class="ma-2"
                        @click="$refs.calendar.prev()"
                      >
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>

                      <v-btn class="ma-2" @click="onClickDate()" text>{{calendar_value | headerDate}}</v-btn>

                      <v-btn
                        icon
                        class="ma-2"
                        @click="$refs.calendar.next()"
                      >
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-sheet height="350">
                      <v-calendar
                        ref="calendar"
                        v-model="calendar_value"
                        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                        type="month"
                        :events="events"
                        :event-color="getEventColor"
                        @change="getEvents"
                        @click:date="getEvents"
                      ></v-calendar>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-banner single-line>
                      {{calendar_value | weekdayDate}}, {{calendar_value | headerDate}}
                      <template v-slot:actions>
                        <v-btn color="primary" :disabled="isDateExpired || isCurrentDayOverrideHoliday" text @click="onAddOverrideWorkingTime()">
                          <v-icon left>mdi-plus</v-icon>Add Unavailability
                        </v-btn>
                      </template>
                    </v-banner>

                    <v-row
                      v-for="(working_period, key) in current_day_override_working_periods"
                      :key="key"
                    >
                      <v-col cols="12" md="4" v-if="working_period.holiday != IS_HOLIDAY">
                        <v-autocomplete
                          class="hide-time-picker-indicator"
                          type="time"
                          menu-props="auto, overflowY"
                          clear-icon="mdi-close"
                          prepend-icon="mdi-clock-outline"
                          clearable
                          outlined
                          hint="Example: 08:00"
                          required
                          v-model="working_period.start_at"
                          :items="timeList"
                          item-text="name"
                          item-value="value"
                          :disabled="working_period.holiday == IS_HOLIDAY"
                          :error-messages="current_day_wp_errors_start_at[key]"
                          dense
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" v-if="working_period.holiday != IS_HOLIDAY">
                        <v-autocomplete
                          class="hide-time-picker-indicator"
                          type="time"
                          menu-props="auto, overflowY"
                          clear-icon="mdi-close"
                          prepend-icon="mdi-clock-outline"
                          clearable
                          outlined
                          hint="Example: 20:00"
                          required
                          v-model="working_period.stop_at"
                          :items="timeList"
                          item-text="name"
                          item-value="value"
                          :disabled="working_period.holiday == IS_HOLIDAY"
                          :error-messages="current_day_wp_errors_stop_at[key]"
                          dense
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="8" v-if="working_period.holiday == IS_HOLIDAY">
                        Unavailable – All Day
                      </v-col>

                      <v-col cols="12" md="2" class="align-self-start">
                        <v-switch class="mt-1" v-model="working_period.holiday" :false-value="IS_REGULAR_DAY" :true-value="IS_HOLIDAY" :label="`Holiday`" @change="onChangeOverrideHoliday(key)" hide-details></v-switch>
                      </v-col>
                      <v-col cols="12" md="2" class="align-self-start pt-2">
                        <v-btn color="error" class="float-right" @click="onRemoveOverrideWorkingPeriod(key)">
                          <v-icon left>mdi-close</v-icon>Remove
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="!current_day_override_working_periods.length">
                      <v-col cols="12" md="12" style="text-align:center">
                        By Unavailability 
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
              <!--/ tab 2 overriden working time -->
            </v-tabs-items>
            <v-row>
              <v-col class="d-flex justify-center">
                <v-btn
                  depressed
                  class="mr-4 primary"
                  :disabled="this.$v.$invalid || localLoading"
                  @click="submit"
                  :loading="localLoading"
                >
                  <v-icon left>mdi-check-box-outline</v-icon>
                  Accept Changes
                </v-btn>
                <v-btn
                  class="warning"
                  depressed
                  @click="cancel"
                  :loading="localLoading"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import * as _ from "lodash";
import moment from "moment";

const IS_HOLIDAY = 10;
const IS_REGULAR_DAY = 20;

export default {
  mixins: [validationMixin],
  name: "EditWorkingTimeModal",
  props: ["thisDriverData"],
  validations: {
  },
  data: () => ({
    driverData: null,
    readOnly: false,
    localLoading: false,
    dialog: false,
    tab_edit_working_time: void 0,
    default_working_times: [],
    working_period_errors_start_at: {},
    working_period_errors_stop_at: {},
    default_working_times_is_valid: true,
    // --
    item_terator_uid: -1,
    override_working_time: [],
    current_day_override_working_periods: [],
    current_day_wp_errors_start_at: [],
    current_day_wp_errors_stop_at: [],
    events: [],
    calendar_value: '',
    override_working_times_is_valid: true,
    IS_HOLIDAY,
    IS_REGULAR_DAY,
  }),
  watch: {
    default_working_times: {
      deep: true,
      handler() {
        this.default_working_times_is_valid = true;
        for (let i = 0; i < 7; i++) {
          this.working_period_errors_start_at[i] = {};
          this.working_period_errors_stop_at[i] = {};

          for (let k = 0; k < this.default_working_times[i].working_periods.length; k++) {
            this.working_period_errors_start_at[i][k] = [];
            this.working_period_errors_stop_at[i][k] = [];

            if (!this.default_working_times[i].working_periods[k].start_at) {
              this.working_period_errors_start_at[i][k].push(
                this.getDayName(i) + " 'Start at' required"
              );
              this.default_working_times_is_valid = false;
            }

            if (!this.default_working_times[i].working_periods[k].stop_at) {
              this.working_period_errors_stop_at[i][k].push(
                this.getDayName(i) + " 'Stop at' required"
              );
              this.default_working_times_is_valid = false;
            }

            // try to find intersections
            for (let k2 = 0; k2 < this.default_working_times[i].working_periods.length; k2++) {
              if (k == k2) continue;

              // start_at
              if (
                   this.default_working_times[i].working_periods[k].start_at >= this.default_working_times[i].working_periods[k2].start_at
                && this.default_working_times[i].working_periods[k].start_at <= this.default_working_times[i].working_periods[k2].stop_at
              ) {
                this.working_period_errors_start_at[i][k].push(
                  this.getDayName(i) + " 'Start at' has intersection with other period"
                );
                this.default_working_times_is_valid = false;
              }

              // stop_at
              if (
                   this.default_working_times[i].working_periods[k].stop_at >= this.default_working_times[i].working_periods[k2].start_at
                && this.default_working_times[i].working_periods[k].stop_at <= this.default_working_times[i].working_periods[k2].stop_at
              ) {
                this.working_period_errors_stop_at[i][k].push(
                  this.getDayName(i) + " 'Stop at' has intersection with other period"
                );
                this.default_working_times_is_valid = false;
              }
            }

            // do not allow stop_at less then start_at
            if (this.default_working_times[i].working_periods[k].stop_at <= this.default_working_times[i].working_periods[k].start_at) {
              this.working_period_errors_stop_at[i][k].push(
                this.getDayName(i) + " 'Start at' can't be greater then 'Stop at'"
              );
              this.default_working_times_is_valid = false;
            }
          }
        }
      },
    },
    current_day_override_working_periods: {
      deep: true,
      handler() {
        this.override_working_times_is_valid = true;
        this.current_day_wp_errors_start_at = [];
        this.current_day_wp_errors_stop_at = [];

        for (let k = 0; k < this.current_day_override_working_periods.length; k++) {
          this.current_day_wp_errors_start_at[k] = [];
          this.current_day_wp_errors_stop_at[k] = [];

          if (!this.current_day_override_working_periods[k].start_at) {
            this.current_day_wp_errors_start_at[k].push(
              this.getDayNameByDate(this.calendar_value) + " 'Start at' required"
            );
            this.override_working_times_is_valid = false;
          }

          if (!this.current_day_override_working_periods[k].stop_at) {
            this.current_day_wp_errors_stop_at[k].push(
              this.getDayNameByDate(this.calendar_value) + " 'Stop at' required"
            );
            this.override_working_times_is_valid = false;
          }

          // try to find intersections
          for (let k2 = 0; k2 < this.current_day_override_working_periods.length; k2++) {
            if (k == k2) continue;

            // start_at
            if (
                  this.current_day_override_working_periods[k].start_at >= this.current_day_override_working_periods[k2].start_at
              && this.current_day_override_working_periods[k].start_at <= this.current_day_override_working_periods[k2].stop_at
            ) {
              this.current_day_wp_errors_start_at[k].push(
                this.getDayNameByDate(this.calendar_value) + " 'Start at' has intersection with other period"
              );
              this.override_working_times_is_valid = false;
            }

            // stop_at
            if (
                  this.current_day_override_working_periods[k].stop_at >= this.current_day_override_working_periods[k2].start_at
              && this.current_day_override_working_periods[k].stop_at <= this.current_day_override_working_periods[k2].stop_at
            ) {
              this.current_day_wp_errors_stop_at[k].push(
                this.getDayNameByDate(this.calendar_value) + " 'Stop at' has intersection with other period"
              );
              this.override_working_times_is_valid = false;
            }
          }

          // do not allow stop_at less then start_at
          if (this.current_day_override_working_periods[k].stop_at <= this.current_day_override_working_periods[k].start_at) {
            this.current_day_wp_errors_stop_at[k].push(
              this.getDayNameByDate(this.calendar_value) + " 'Start at' can't be greater then 'Stop at'"
            );
            this.override_working_times_is_valid = false;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
        timeList: 'timeList',
    }),
    isDateExpired() {
      return this.calendar_value < moment().format('YYYY-MM-DD');
    },
    isCurrentDayOverrideHoliday() {
      if (_.find(this.current_day_override_working_periods, p => p.holiday == IS_HOLIDAY)) {
        return true;
      }

      return false;
    }
  },
  mounted() {
    this.driverData = this.thisDriverData;
    this.calendar_value = moment().format('YYYY-MM-DD');

    // fill week
    let default_working_times = [];

    let default_working_time_items = _.map(this.thisDriverData.default_working_time, p => {
        let item = _.clone(p);

        item.start_at = moment(item.start_at, "HH:mm").format('HH:mm');
        item.stop_at = moment(item.stop_at, "HH:mm").format('HH:mm');

        return item;
      }
    );
    
    for (let weekday_index = 0; weekday_index < 7; weekday_index++) {
      // 0=Monday - 6=Sunday

      let working_periods = _.filter(
        default_working_time_items,
        (p) => p.week_day == weekday_index
      );

      default_working_times.push({
        weekday_index: weekday_index,
        weekday_name: this.getDayName(weekday_index),
        working_periods: working_periods,
      });
    }

    this.default_working_times = default_working_times;
    this.override_working_time = _.map(this.thisDriverData.actual_override_working_time, p => {
        let item = _.clone(p);

        item.start_at = moment(item.start_at, "HH:mm").format('HH:mm');
        item.stop_at = moment(item.stop_at, "HH:mm").format('HH:mm');

        return item;
      }
    );

    this.getEvents(); // refresh
  },

  methods: {
    cancel() {
      // fill week
      let default_working_times = [];

      let default_working_time_items = _.map(this.thisDriverData.default_working_time, p => {
          let item = _.clone(p);

          item.start_at = moment(item.start_at, "HH:mm").format('HH:mm');
          item.stop_at = moment(item.stop_at, "HH:mm").format('HH:mm');

          return item;
        }
      );
      
      for (let weekday_index = 0; weekday_index < 7; weekday_index++) {
        // 0=Monday - 6=Sunday

        let working_periods = _.filter(
          default_working_time_items,
          (p) => p.week_day == weekday_index
        );

        default_working_times.push({
          weekday_index: weekday_index,
          weekday_name: this.getDayName(weekday_index),
          working_periods: working_periods,
        });
      }

      this.default_working_times = default_working_times;
      this.override_working_time = _.map(this.thisDriverData.actual_override_working_time, p => {
          let item = _.clone(p);

          item.start_at = moment(item.start_at, "HH:mm").format('HH:mm');
          item.stop_at = moment(item.stop_at, "HH:mm").format('HH:mm');

          return item;
        }
      );

      this.getEvents(); // refresh

      this.dialog = false;
    },
    submit() {
      this.localLoading = true;
      this.dialog = true;
      this.$v.$touch();

      if (!this.$v.$invalid && this.default_working_times_is_valid && this.override_working_times_is_valid) {
        let default_working_times = []
        let override_working_time = [];

        _.each(this.default_working_times, p => {
          let items = _.map(
            p.working_periods,
            p => {
              return {
                // id: p.id
                week_day: p.week_day,
                holiday: p.holiday,
                start_at: p.start_at,
                stop_at: p.stop_at,
              }
            }
          );

          default_working_times = _.concat(default_working_times, items);
        });

        override_working_time = _.map(this.override_working_time, p => {
          return {
            period_date: p.period_date,
            holiday: p.holiday,
            start_at: p.start_at,
            stop_at: p.stop_at,
          }
        });

        let work_time_data = {
          driver_id: this.driverData.id,
          default_working_times: default_working_times,
          override_working_time: override_working_time,
        };

        this.$store.dispatch('editWorkingTimes', work_time_data).then(() => {
          this.dialog = false;
          this.password = '';
          this.switch_change_password = false;
          this.$emit('driverUpdated', '');
        })
        .catch(error => {
          this.email = '';
          let errors = error.response;
          this.$store.dispatch('setError', errors[Object.keys(errors)[0]][0]);
        }).finally(() => {
          this.localLoading = false;
        });

      }
    },
    onAddWorkingPeriod(index) {
      this.default_working_times[index].working_periods.push({
        week_day: index,
        holiday: IS_REGULAR_DAY,
        start_at: void 0,
        stop_at: void 0,
      });
    },
    onRemoveWorkingPeriod(index1, index2) {
      this.default_working_times[index1].working_periods.splice(index2, 1);
    },
    onChangeHoliday(index1, index2) {
      // remove all others
      this.default_working_times[index1].working_periods[index2].start_at = _.first(this.timeList).value;
      this.default_working_times[index1].working_periods[index2].stop_at = _.last(this.timeList).value;
      this.default_working_times[index1].working_periods = [
        this.default_working_times[index1].working_periods[index2]
      ];
    },
    isCurrentDayHasHoliday(index) {
      if (_.find(this.default_working_times[index].working_periods, p => p.holiday == IS_HOLIDAY)) {
        return true;
      }

      return false;
    },
    // --
    onAddOverrideWorkingTime() {
      this.current_day_wp_errors_start_at[this.calendar_value] = [];
      this.current_day_wp_errors_stop_at[this.calendar_value] = [];
      
      let new_item = {
        id: --this.item_terator_uid,
        period_date: this.calendar_value,
        holiday: IS_REGULAR_DAY,
        start_at: void 0,
        stop_at: void 0,
      };

      this.override_working_time.push(new_item);
      this.getEvents(); // refresh
      // this.current_day_override_working_periods.push(new_item)
    },
    onRemoveOverrideWorkingPeriod(index) {
      let item_index = _.findIndex(this.override_working_time, p => p.id == this.current_day_override_working_periods[index].id);
      
      this.override_working_time.splice(item_index, 1);
      this.getEvents(); // refresh
    },
    onChangeOverrideHoliday(index) {
      // remove all others on this day
      let new_item = _.clone(this.current_day_override_working_periods[index]);
      new_item.start_at = _.first(this.timeList).value;
      new_item.stop_at = _.last(this.timeList).value;

      for (let i = 0; i < this.current_day_override_working_periods.length; i++) {
        this.override_working_time = _.filter(this.override_working_time, p => p.period_date != new_item.period_date);
      }

      this.override_working_time.push(new_item);

      this.getEvents(); // refresh
    },
    onClickDate() {
      this.calendar_value = moment().format('YYYY-MM-DD');
    },
    getEvents() {
      this.current_day_override_working_periods = _.filter(this.override_working_time, p => p.period_date == this.calendar_value);
      let by_date = _.groupBy(this.override_working_time, p => p.period_date);

      this.events = _.map(by_date, p => {
        let item = _.first(p);
        if (item.holiday == IS_HOLIDAY) {
          return {
            name: 'Holiday',
            color: 'green',
            start: item.period_date,
            end: item.period_date,
            timed: false, // !allDay
          }
        }

        return {
          name: 'Custom schedulle',
          color: 'blue',
          start: item.period_date,
          end: item.period_date,
          timed: false, // !allDay
        }
      });
    },
    getEventColor(event) {
      return event.color;
    },
    getDayName(day_number) {
      return moment().isoWeekday(day_number+1).format("dddd");
    },
    getDayNameByDate(date) {
      return moment(date, "YYYY-MM-DD").format("dddd");
    },
  },
  filters: {
    headerDate: function (date) {
      return moment(date, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    weekdayDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("dddd");
    },
  },
};
</script>

<style scoped>
</style>